/**
 * Created by jonas on 2019-09-09.
 */
import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {WinterHoardGameAssets} from "../WinterHoardGameAssets";
import {TimelineLite, TweenMax} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DevOutline} from "@nolimitcity/slot-game/bin/dev/DevOutline";
import {DevCrossHair} from "@nolimitcity/slot-game/bin/dev/DevCrossHair";
import {DevConsole} from "@nolimitcity/slot-launcher/bin/devtools/DevConsole";



export class DevToolsDemoView extends BaseView {
    private _layer:ScalableLayer;
    private _sprite:PIXI.Sprite;
    private _tl:TimelineLite | null;

    constructor() {
        super();
        this._layer = StageManager.getLayer(WinterHoardLayerConfig.DEMO.name);
    }


    protected initAnimations():void {
        this._sprite = new PIXI.Sprite(WinterHoardGameAssets.getSymbolStateTextures("W")[0]);
        this._sprite.anchor.set(0.5,0.5);
        this.addChild(this._sprite);

        this._sprite.addChild(new DevOutline());
        this._sprite.addChild(new DevCrossHair(true));

/*
        DevKeyTriggerManager.addTrigger("t", () => this.run(), "Play/Pause on the demo animation");
        DevKeyTriggerManager.addTrigger("y", () => this.stop(), "Kills the demo animation");*/
        DevConsole.addCommand("demoRun", () => this.run());
        DevConsole.addCommand("demoStop", () => this.stop());
    }


    public run() {
        if (this._tl && this._tl.paused()){
            this._tl.play();
            return;
        }else if (this._tl && !this._tl.paused()){
            this._tl.pause();
            return;
        }
        this._tl = new TimelineLite();
        this._layer.addChild(this);
        this._tl.set(this._sprite.position, {x:0,y:200});
        this._tl.add(new TweenMax(this._sprite.position,2,{x:720,y:200, repeat:-1, yoyo:true, yoyoEase:true}));
    }



    public stop() {
        this._layer.removeChild(this);
        if (this._tl){
            this._tl.kill();
        }
        this._tl = null;
    }

}